import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// components
import { Box, Button, Stack } from '@mui/material';
import { IconButtonAnimate } from 'src/components/animate';
import Iconify from 'src/components/iconify';
import VoterLookupModal from './VoterLookupModal';

function VoterLookupButton() {
  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);

  const isApple = navigator.userAgent.toUpperCase().indexOf('MAC') >= 0;

  useEffect(() => {
    if (open) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleKeyDown = (event: React.KeyboardEvent) => {
      // Check if 'Command + K' or 'Ctrl + K' was pressed
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault(); // Prevent the default action to avoid conflicts
        setOpen(true);
      }
    };

    // Add event listener for keyboard shortcuts
    window.addEventListener('keydown', handleKeyDown as unknown as EventListener);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown as unknown as EventListener);
    };
  }, []); // Empty dependency array means this effect runs only once on mount

  return (
    <Box>
      <Stack direction="row" gap={0} alignItems="center">
        <IconButtonAnimate onClick={handleOpen}>
          <Iconify icon="eva:search-fill" />
        </IconButtonAnimate>
        <Button
          onClick={handleOpen}
          variant="soft"
          color="secondary"
          size="small"
          sx={{
            marginLeft: 0.5,
            paddingLeft: 1,
            paddingRight: 1,
            fontSize: '.75em',
            lineHeight: '1em',
            minWidth: 'auto',
            height: '24px',
          }}
        >
          {isApple ? '⌘' : 'Ctrl '}K
        </Button>
      </Stack>
      <VoterLookupModal open={open} onClose={handleClose} />
    </Box>
  );
}

export default VoterLookupButton;
